import { connect, useDispatch } from "react-redux";
import React, { useState } from "react";
import { Button, message } from "antd";
import { FaMagic } from "react-icons/fa";
import { get, pick } from "lodash";
import { ASSET_URL, URL_API_CREATE_CUSTOM_HANDWRITING, URL_API_UPLOAD_IMAGE_HANDWRITING, XKEY_API_CREATE_CUSTOM_HANDWRITING, XKEY_API_UPLOAD_IMAGE_HANDWRITING } from "../../../../config";
import axios from "axios";
import { uniqueID } from "../../Utilities/helper";
import { ARTWORK } from "../../../../types";

const HandWritingSettings = ({layer}) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false)

    async function imageUrlToBase64Browser(url) {
        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

            const blob = await response.blob();

            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result); // Trả về data:image/...;base64,...
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error('Error converting URL to base64:', error);
            throw error;
        }
    }


    const getSignedUrl = async (mime, size) => {
        var headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("X-ABN-KEY", XKEY_API_UPLOAD_IMAGE_HANDWRITING);
        var requestOptions = {
          method: "GET",
          headers: headers,
          redirect: "follow",
        };
        var signedUrl = null;
        await fetch(`${URL_API_UPLOAD_IMAGE_HANDWRITING}/signedUrl?type=${mime}&size=${size}`, requestOptions)
          .then((response) => response.json())
          .then((res) => (signedUrl = res))
          .catch((err) => console.error(err));
        return signedUrl;
      };

    const upload = async (base64) => {
        var file = await fetch(base64)
          .then((res) => res.arrayBuffer())
          .then((buf) => new File([buf], "tmp.png", { type: "image/png" }));
        var signedUrl = await getSignedUrl(file.type, file.size);
        await axios
          .put(signedUrl.upload_url, file, {
            headers: {
              "Content-Type": file.type,
            },
          })
          .catch((err) => console.error(err));
        return '/' + signedUrl.key;
      };

    

    const handleRecreate = async () => {
        setLoading(true);
        const keyMessage = "creLayerWritingSettings";
        message.loading({
            content: "Creating image...",
            key: keyMessage,
            duration: 0,
        });
        try {
            const key = get(layer, 'values[0].file.key').replace(/^\//, '');

            const base64 = await imageUrlToBase64Browser(ASSET_URL + key);
            const upfile = await upload(base64);
            const response = await axios.post(URL_API_CREATE_CUSTOM_HANDWRITING, {
                image_file: upfile
            },
                {
                    headers: {
                        "X-ABN-KEY": XKEY_API_CREATE_CUSTOM_HANDWRITING,
                        "Content-Type": "application/json"
                    }
                }
            ).then(res => {
                return {
                    id: uniqueID(),
                    key: get(res, 'data.image_file', '').replace(/^\//, '')
                }
            }).catch(error => {
                return false;
            });

            if (!response){
                message.error({
                    content: "Failure!!",
                    key: keyMessage,
                    duration: 4,
                });
                setLoading(false);
                return;
            }

            const valuesLayer = get(layer, "values", []);
            valuesLayer[0].file = pick(response, ["id", "key"]);
            dispatch({
                type: ARTWORK.SET_LAYER,
                payload: {
                    ...layer,
                    values: valuesLayer,
                    isHandwritingProcessing: true
                },
            });
            message.success({
                content: "Successfully!",
                key: keyMessage,
                duration: 4,
            });
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
        

    }
    return (layer.imageHandWriting && !layer.isHandwritingProcessing) ? <>
        <Button
            loading={loading}
            style={{
                height: "35px",
                width: "100%",
                fontSize: "16px",
                fontWeight: "600",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
            type="primary"
            onClick={handleRecreate}
            icon={
                <FaMagic
                    style={{
                        marginRight: 3,
                    }}
                />
            }
        >
            Handwriting Processing
        </Button>
    </> : null;
}

export default connect((state) => ({
  workspace: state.artwork.workspace,
}))(HandWritingSettings);